<!--
 * @Author: hl
 * @Date: 2023-03-18 15:29:12
 * @LastEditors: hl
 * @LastEditTime: 2023-03-18 15:56:42
-->
<template>
  <div class="nodata">
    <img src="../../../static/img/com_invitteFriend/no_date.png" alt="" />
    <div class="text">这里现在空空如也，等一下再过来吧</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.nodata {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    height: 40vw;
    width: 40vw;
  }
  .text {
    font-size: 3.2vw;
    font-weight: 400;
    color: #de9759;
    margin-top: 3.733333vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hongbao_new/common/no_data.vue